<template>
  <div class="calico-loan-profile-pattern">
    <div
      v-if="!hasLoanData"
      class="checklist"
    >
      <div class="checklist-item">
        <div>
          <p class="body--medium">
            {{ loanProfileLabel }}
          </p>
          <p class="body--xsmall">
            {{ loanProfileDescription }}
          </p>
        </div>
        <div style="width: fit-content;">
          <button
            type="button"
            class="button-primary button-primary--small"
            @click="$emit('complete')"
          >
            Complete
          </button>
        </div>
      </div>
    </div>

    <template v-else>
      <CalicoCardInfo
        label="Amount"
        :content="formattedAmount"
        variant="light"
      />
      <CalicoCardInfo
        v-if="type"
        label="Loan Type"
        :content="type"
        variant="light"
      />
      <CalicoCardInfo
        v-if="use"
        label="Use"
        :content="use"
        variant="light"
      />
      <CalicoCardInfo
        v-if="personalCreditScore"
        label="Personal Credit Score"
        :content="personalCreditScore"
        variant="light"
      />
      <div class="edit-item">
        <div style="width: fit-content;">
          <button
            v-if="edit"
            type="button"
            class="button-tertiary--small"
            @click="$emit('edit')"
          >
            <i class="bi bi-pencil" />
            Edit
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CalicoCardInfo from '@/components/calico/cardInfo/index.vue'
import { formatCurrency } from '@/utils/helper'
import { LoanBeaconCopy } from '@/enums'

export default {
  name: 'LoanProfile',

  components: {
    CalicoCardInfo,
  },

  props: {
    amount: {
      type: [Number, String],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    use: {
      type: String,
      default: null,
    },
    personalCreditScore: {
      type: String,
      default: null,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['edit', 'complete'],

  computed: {
    hasLoanData() {
      return !!(this.amount || this.type || this.use || this.personalCreditScore)
    },
    formattedAmount() {
      return formatCurrency(this.amount)
    },
    loanProfileLabel() {
      return LoanBeaconCopy.LOAN_PROFILE_LABEL
    },
    loanProfileDescription() {
      return LoanBeaconCopy.LOAN_PROFILE_DESCRIPTION
    },
  },
}
</script>

<style scoped lang="scss">
.calico-loan-profile-pattern {
  @include stack-space($space-medium);
  display: flex;
  flex-direction: column;

  .checklist {
    @include stack-space($space-small);

    .checklist-item {
      @include inline-space($space-medium);
      align-items: center;
      justify-content: space-between;
    }
  }

  .edit-item {
    @include inline-space($space-medium);
    justify-content: flex-end;
  }
}
</style>